// tslint:disable-next-line:ter-max-len
const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{2,24}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)/;

export const isValidUrl = (url: string): boolean => {
  return URL_REGEX.test(url);
};
